import { useOfflineStatus as useOfflineStatusCore } from '@/connection/hooks';

// Pure leaf hook - just wraps context, no side effects
export const useOfflineStatus = () => {
  return useOfflineStatusCore();
};